import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_COMPANY_MANAGEMENT_DATA =
  "paginationCompanyManagementData";
export const LIST_COMPANY_MANAGEMENT_DATA = "listCompanyManagementData";
export const GET_COMPANY_MANAGEMENT_DATA = "getCompanyManagementData";
export const POST_COMPANY_MANAGEMENT_DATA = "postCompanyManagementData";
export const PUT_COMPANY_MANAGEMENT_DATA = "putCompanyManagementData";
export const PUT_COMPANY_MANAGEMENT_STATUS_DATA =
  "putCompanyManagementStatusData";
export const DELETE_COMPANY_MANAGEMENT_DATA = "deleteCompanyManagementData";
export const LIST_PLANS = "listPlans";
export const GET_COMPANY_PLAN = "getCompanyPlan";
export const PUT_COMPANY_PLAN = "putCompanyPlan";
export const PUT_COMPANY_MEMBER_TIER = "putCompanyMemberTier";
export const LIST_TOPUP_PACKS = "listTopupPacks";
export const GET_COMPANY_TOPUP = "getCompanyTopup";
export const POST_COMPANY_TOPUP = "postCompanyTopup";
export const LIST_COMPANY_RECEIPT_TYPE = "listCompanyReceiptType";
export const CREATE_COMPANY_RECEIPT_TYPE = "createCompanyReceiptType";
export const UPDATE_COMPANY_RECEIPT_TYPE = "updateCompanyReceiptType";
export const DELETE_COMPANY_RECEIPT_TYPE = "deleteCompanyReceiptType";
export const PAGINATION_COMPANY_BANK_ACCOUNT = "paginationCompanyBankAccount";
export const LIST_COMPANY_BANK_ACCOUNT = "listCompanyBankAccount";
export const CREATE_COMPANY_BANK_ACCOUNT = "createCompanyBankAccount";
export const UPDATE_COMPANY_BANK_ACCOUNT = "updateCompanyBankAccount";
export const DELETE_COMPANY_BANK_ACCOUNT = "deleteCompanyBankAccount";
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "company_management",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [LIST_COMPANY_MANAGEMENT_DATA](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [GET_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`);
    },
    [POST_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [PUT_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [PUT_COMPANY_MANAGEMENT_STATUS_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/status/${payload.id}`,
        payload.data
      );
    },
    [DELETE_COMPANY_MANAGEMENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    },
    [LIST_PLANS]() {
      ApiService.setHeader();
      return ApiService.getParams("plans");
    },
    [GET_COMPANY_PLAN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}/plan`);
    },
    [PUT_COMPANY_PLAN](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}/plan`,
        payload.data
      );
    },
    [PUT_COMPANY_MEMBER_TIER](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}/member_tier`,
        payload.data
      );
    },
    [LIST_TOPUP_PACKS]() {
      ApiService.setHeader();
      return ApiService.getParams("ai_quota/topup/catalog");
    },
    [GET_COMPANY_TOPUP](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/${payload.id}/ai_quota/topup`
      );
    },
    [POST_COMPANY_TOPUP](context, payload) {
      ApiService.setHeader();
      return ApiService.post(
        `${context.state.path}/${payload.id}/ai_quota/topup/apply`,
        payload.data
      );
    },
    [LIST_COMPANY_RECEIPT_TYPE](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/${payload.id}/receipt_type`
      );
    },
    [CREATE_COMPANY_RECEIPT_TYPE](context, payload) {
      ApiService.setHeader();
      return ApiService.post(
        `${context.state.path}/${payload.id}/receipt_type`,
        payload.data
      );
    },
    [UPDATE_COMPANY_RECEIPT_TYPE](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}/receipt_type/${payload.receiptTypeId}`,
        payload.data
      );
    },
    [DELETE_COMPANY_RECEIPT_TYPE](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(
        `${context.state.path}/${payload.id}/receipt_type/${payload.receiptTypeId}`
      );
    },
    [PAGINATION_COMPANY_BANK_ACCOUNT](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/${payload.id}/bank_account/pagination`,
        { params: payload.params }
      );
    },
    [LIST_COMPANY_BANK_ACCOUNT](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/${payload.id}/bank_account`
      );
    },
    [CREATE_COMPANY_BANK_ACCOUNT](context, payload) {
      ApiService.setHeader();
      return ApiService.post(
        `${context.state.path}/${payload.id}/bank_account`,
        payload.data
      );
    },
    [UPDATE_COMPANY_BANK_ACCOUNT](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}/bank_account/${payload.bankAccountId}`,
        payload.data
      );
    },
    [DELETE_COMPANY_BANK_ACCOUNT](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(
        `${context.state.path}/${payload.id}/bank_account/${payload.bankAccountId}`
      );
    }
  },
  mutations: {
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
